import { call, select, race, take, delay, put } from 'redux-saga/effects';
import { createSelector } from 'reselect';
import { ctaLabelSelectorProps } from '@grandvisionhq/configurator';
import { statusSuccess, statusFailed, actions } from '@grandvisionhq/state';
import { LensAddOnStepContainer } from '../../../../Configurator/steps/LensAddOnStep/LensAddOnStepContainer.js';
import { getSelectedAddOn, getFrameSku, getSelectedPackage, getAddOns, getSelectedLensType } from '../../selectors.js';
import { fetchAddOnsSuccess, fetchAddOnsFailed } from '../../../bundles/actions.js';
import { selectAddOn } from '../../../configurations/actions.js';

const lensAddOnStepBase = {
    *onEnter () {
        yield call(selectDefaultAddOn);
    },
    ctaLabel: createSelector(ctaLabelSelectorProps, getSelectedAddOn, ({ defaultCtaLabel , alternativeCtaLabel  }, selectedAddOn)=>{
        var ref;
        return Number(selectedAddOn === null || selectedAddOn === void 0 ? void 0 : (ref = selectedAddOn.variants) === null || ref === void 0 ? void 0 : ref.length) > 1 && alternativeCtaLabel ? {
            key: alternativeCtaLabel
        } : {
            key: defaultCtaLabel
        };
    }),
    view: LensAddOnStepContainer
};
const isSuccess = ({ packageSku  })=>(a)=>actions.isType(a, fetchAddOnsSuccess) && a.payload.packageSku === packageSku
;
const isFailed = ({ packageSku  })=>(a)=>actions.isType(a, fetchAddOnsFailed) && a.payload.packageSku === packageSku
;
function* selectDefaultAddOn() {
    const selectedAddOn = yield select(getSelectedAddOn);
    if (!selectedAddOn) {
        const frameSku = yield select(getFrameSku);
        if (!frameSku) {
            return;
        }
        const selectedPackage = yield select(getSelectedPackage);
        let addOns = yield select(getAddOns);
        if (!statusSuccess(addOns) && !statusFailed(addOns)) {
            // If it's still loading we're going to wait a bit for the loading to finish
            const lensType = yield select(getSelectedLensType);
            if (!lensType) {
                return;
            }
            if (!selectedPackage) {
                return;
            }
            const [success] = yield race([
                take(isSuccess({
                    packageSku: selectedPackage.sku
                })),
                take(isFailed({
                    packageSku: selectedPackage.sku
                })),
                delay(30000, true), 
            ]);
            if (success) {
                addOns = yield select(getAddOns);
            }
        }
        if (statusSuccess(addOns)) {
            var ref;
            /**
       * Select the cheapest product that has the 'default' attribute set to true
       * If no product is set as default, select the cheapest one
       */ //make sure this is low to high
            const products = addOns.result;
            const variants = products.reduce((acc, p)=>[
                    ...acc,
                    p,
                    ...p.variants || []
                ]
            , []);
            let addOnSku = (selectedPackage === null || selectedPackage === void 0 ? void 0 : selectedPackage.areAddOnsOptional) ? '' : (ref = addOns.result[0]) === null || ref === void 0 ? void 0 : ref.sku;
            for (const variant of variants){
                if (variant.isDefault) {
                    addOnSku = variant.sku;
                    break;
                }
            }
            if (addOnSku) {
                yield put(selectAddOn({
                    frameSku,
                    addOnSku,
                    reason: 'default selection'
                }));
            }
        }
    }
}

export { lensAddOnStepBase, selectDefaultAddOn };
//# sourceMappingURL=lens-add-on.js.map
